import React from 'react';
import _ from 'lodash';
import { Tooltip } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import TeamAvatar from 'components/base/TeamAvatar';
import { sizes } from 'styles/dropdown.style';

const formatPathForSearchResult = (name, path = []) => {
  const pathFormatted = path.map(({ name }) => name).join('/');
  const nameFormatted = path.length ? `/${name}` : name;
  return (
    <Tooltip
      title={`${pathFormatted}${nameFormatted}`}
      id='increaseTooltipZIndex'
      enterNextDelay={1000}
    >
      <Flex>
        <Text size='large' color='shark' ellipsisAfter='30rem'>
          {pathFormatted}
        </Text>
        <Text size='large' color='shark' weight='bold'>
          {nameFormatted}
        </Text>
      </Flex>
    </Tooltip>
  );
};

const TreeTeamsOption = ({
  team,
  isSearchMode = false,
  isBoldedValue,
  size = 'medium'
}) => {
  const { textSize, avatarSize } = _.get(sizes, [size], {});

  const { path, origin = {} } = team;
  const { name } = origin;
  return (
    <>
      <Flex pr='normal'>
        <TeamAvatar team={origin} size={avatarSize} />
      </Flex>
      {isSearchMode ? (
        formatPathForSearchResult(name, path)
      ) : (
        <Tooltip title={name} id='increaseTooltipZIndex' enterNextDelay={1000}>
          <Text size={textSize} pr='1.5rem' ellipsisAfter='100%'>
            {isBoldedValue ? <b>{name}</b> : name}
          </Text>
        </Tooltip>
      )}
    </>
  );
};

export default TreeTeamsOption;
